export default "__VITE_ASSET__C1EJ3oe0__"